function formatNewUserPayload(payload) {
  const result = {};
  if (payload && payload.ssn) {
    result.ssn = payload?.ssn?.replace(/-/g, '');
  }
  const dateString = payload.dob_day;
  if (dateString?.match) {
    const [month, day, year] = dateString.match(/(\d{2})\/(\d{2})\/(\d{4})/).slice(1);
    result.dob_day = parseInt(day, 10);
    result.dob_month = parseInt(month, 10);
    result.dob_year = parseInt(year, 10);
  }

  return result;
}
export default formatNewUserPayload;
